<template>
  <div>
    <!-- Table rows -->
    <div v-for="(document, docIndex) in documents" :key="docIndex"
      class="table-row columns is-multiline is-variable is-mobile is-5">
      <!-- Table col for document name -->
      <div :class="`column is-12-mobile ${headings.col1.classes}`">
        <div class="table-col">
          <div
            v-if="docIndex === 0"
            class="col-header"
            v-html="headings.col1.name"
            v-translate>
          </div>
          <div>
            <strong>{{ document.title }}</strong>
          </div>
        </div>
      </div>
      <!-- Table col for files -->
      <div :class="`column is-12-mobile ${headings.col2.classes}`">
        <div class="table-col">
          <div
            v-if="docIndex === 0"
            v-html="headings.col2.name"
            v-translate>
          </div>
          <div v-for="(file, index) in document.files" :key="rerenderDoc + index" class="col-document">
            <a :href="file.url" target="_blank" download>{{ file.name }}</a>
          </div>
        </div>
      </div>
      <!-- Table col for files uploaded date -->
      <div :class="`column is-12-mobile ${headings.col3.classes}`">
        <div class="table-col">
          <div
            v-if="docIndex === 0"
            v-html="headings.col3.name"
            v-translate>
          </div>
          <div v-for="(file, index) in document.files" :key="index">
            {{ file.updated }}
          </div>
        </div>
      </div>
      <!-- Table col for actions -->
      <div v-if="actionItems.length" :class="`column is-12-mobile ${headings.col4.classes}`">
        <div class="table-col">
          <div
            v-if="docIndex === 0"
            v-html="headings.col4.name || '&nbsp;'"
            v-translate>
          </div>
          <slot :actionItem="actionItems[docIndex]"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Document } from '@/classes/case/Document'

  export default {
    name: 'documents-table-component',
    data () {
      return {
        rerenderDoc: 0
      }
    },
    props: {
      headings: {
        type: Object,
        default: () => ({
          col1: { name: 'Documents', classes: 'is-4-tablet is-3-desktop' },
          col2: { name: 'Filename', classes: 'is-4-tablet is-6-desktop' },
          col3: { name: 'Uploaded at', classes: 'is-4-tablet is-3-desktop' }
        })
      },
      documents: {
        type: Array,
        validator: (prop) => prop.every(e => e instanceof Document),
        required: true
      },
      actionItems: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      rerenderDOMElement () {
        this.rerenderDoc++
      }
    }
  }
</script>
<style lang="sass" scoped>
  .file-delete-container
    position: absolute
    top: -5px
    right: 0
  .table-col
    color: #4D4D4D
    .col-header
      margin-bottom: 0.5rem
    .col-document
      position: relative
      padding-right: 1.5em
      a
        width: 100%
        display: inline-block
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
</style>
